import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { User } from "../../types";
import * as Yup from "yup";
import { FormControl, Input, Stack } from "@chakra-ui/react";
import { Label } from "../Label";
import { FormButton } from "../FormButton";
import { PrimayButton } from "../Button";

type Props = {
  user: User;
  isSubmitting: boolean;
  onSubmit: (values: any) => void;
};

export const AccountProfileForm: React.FC<Props> = ({
  user,
  isSubmitting,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      email: user.email,
      newPassword: "",
      confirmNewPassword: "",
    },
    enableReinitialize: true,
    onSubmit: onSubmit,
    validationSchema: Yup.object().shape({
      email: Yup.string().required(t("profile.emailRequired")),
      newPassword: Yup.string().required(t("profile.emailRequired")),
      confirmNewPassword: Yup.string().required(t("profile.emailRequired")),
    }),
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing={"1rem"} direction={"column"}>
        <FormControl>
          <Label>{t("profile.email")}</Label>
          <Input
            size="lg"
            name={"email"}
            value={formik.values.email}
            onChange={formik.handleChange}
            disabled
          />
        </FormControl>
        <FormControl>
          <Label>{t("profile.newPassword")}</Label>
          <Input
            size="lg"
            name={"newPassword"}
            value={formik.values.newPassword}
            type={"password"}
            onChange={formik.handleChange}
          />
        </FormControl>
        <FormControl>
          <Label>{t("profile.confirmNewPassword")}</Label>
          <Input
            size="lg"
            name={"confirmNewPassword"}
            value={formik.values.confirmNewPassword}
            type={"password"}
            onChange={formik.handleChange}
          />
        </FormControl>

        <PrimayButton type="submit" isLoading={isSubmitting}>
          {t("screens.login.button")}
        </PrimayButton>
      </Stack>
    </form>
  );
};
